// 埋点 Hook - 独立封装，不影响现有逻辑

// 声明 gtag 全局类型
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const useTracking = () => {
  // 检查 gtag 是否可用
  const isGtagAvailable = () => {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
  };

  // 检查是否为生产环境
  const isProduction = () => {
    return !['localhost', '127.0.0.1'].includes(window.location.hostname);
  };

  // 通用埋点方法
  const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
    if (!isGtagAvailable() || !isProduction()) {
      console.log('埋点事件:', eventName, parameters);
      return;
    }

    try {
      window.gtag('event', eventName, parameters);
    } catch (error) {
      console.error('埋点发送失败:', error);
    }
  };

  // 注册相关埋点 - 支持外部传入参数
  const trackSignupClick = (location: string) => {
    trackEvent('signup_click', {
      event_category: 'cta_button',
      event_label: location,
    });
  };
  // 登录相关埋点 - 支持外部传入参数
  const trackLoginClick = (location: string) => {
    trackEvent('login_click', {
      event_category: 'cta_button',
      event_label: location,
    });
  };

  // 联系按钮埋点 - 根据位置区分
  const trackContactClick = (location: string) => {
    trackEvent('contact_click', {
      event_category: 'cta_button',
      event_label: location,
    });
  };
  // 自定义事件埋点
  const trackCustomEvent = (eventName: string, parameters?: Record<string, any>) => {
    trackEvent(eventName, parameters);
  };
  return {
    trackEvent,
    trackSignupClick,
    trackLoginClick,
    trackCustomEvent,
    trackContactClick,
    isGtagAvailable,
    isProduction,
  };
};
